import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Home            from './pages/Home/Home';
import About           from './pages/About/About';
import Portfolio       from './pages/Portfolio/Portfolio';
import Blog            from './pages/Blog/Blog';
import BlogPost        from './pages/BlogPost/BlogPost';
import Testimonials    from './pages/Testimonials/Testimonials';
import Mentorship      from './pages/Mentorship/Mentorship';
import SignUp          from './pages/SignUp/SignUp';
import DocumentProject from './pages/DocumentProject/DocumentProject';
import ProjectPage     from './pages/ProjectPage/ProjectPage';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <div key={location.pathname} className="page-enter">
      <Routes location={location}>
        <Route path="/"             element={<Home />} />
        <Route path="/about"        element={<About />} />
        <Route path="/portfolio"    element={<Portfolio />} />
        <Route path="/blog"         element={<Blog />} />
        <Route path="/blog/:slug"   element={<BlogPost />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/mentorship"   element={<Mentorship />} />
        <Route path="/signup"       element={<SignUp />} />
        <Route path="/document"     element={<DocumentProject />} />
        <Route path="/projects/:slug" element={<ProjectPage />} />
        <Route path="*"             element={<Home />} />
      </Routes>
    </div>
  );
};

const App = () => (
  <>
    <ScrollToTop />
    <Navbar />
    <AnimatedRoutes />
    <Footer />
  </>
);

export default App;
